import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavListItem } from '../../navigation.component';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { User } from 'anchor-shared/lib/model/entity/user';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-profile-list',
  templateUrl: './nav-profile-list.component.html',
  styleUrls: ['./nav-profile-list.component.scss'],
})
export class NavProfileListComponent {
  @Input() navProfileItems: NavListItem[];
  @Input() user: User;

  subs: Subscription[] = [];

  constructor(private router: Router) {}

  onItemClick(item: NavListItem): void {
    if (item.action) {
      item.action();
    } else if (item.route) {
      if (item.isExternal) {
        window.open(item.route, '_blank');
      } else {
        if (item.routeParams) {
          this.router.navigate([item.route], { queryParams: item.routeParams });
        } else {
          this.router.navigateByUrl(item.route);
        }
      }
    }
  }
}
